import React from 'react';
import {Box, Flex, IconButton} from '@chakra-ui/react';
import {useNavigate} from 'react-router-dom';
import TabSwitcher from '../../../components/TabSwitcher';

type ActiveTab = 'profile' | 'plans';

interface NeighborProfileHeaderProps {
  activeTab: ActiveTab;
  onTabChange: (tab: ActiveTab) => void;
  onMenuOpen: () => void;
}

const NeighborProfileHeader = ({activeTab, onTabChange, onMenuOpen}: NeighborProfileHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Box bg="white">
      <Flex px={4} pt={4} pb={1} justify="space-between" align="center">
        <IconButton
          aria-label="Go back"
          variant="ghost"
          borderRadius="full"
          size="sm"
          icon={<i className="fi fi-rr-arrow-left" aria-hidden="true" style={{fontSize: '18px'}} />}
          onClick={() => navigate(-1)}
        />
        <Box position="relative">
          <IconButton
            aria-label="More options"
            variant="ghost"
            borderRadius="full"
            size="sm"
            icon={<i className="fi fi-rr-menu-dots" aria-hidden="true" style={{fontSize: '18px'}} />}
            onClick={onMenuOpen}
          />
        </Box>
      </Flex>

      <TabSwitcher
        ariaLabel="Profile sections"
        activeTab={activeTab}
        onChange={onTabChange}
        tabs={[
          {value: 'profile', label: 'Profile', panelId: 'neighbor-profile-panel'},
          {value: 'plans', label: 'Their Plans', panelId: 'neighbor-plans-panel'},
        ]}
      />
    </Box>
  );
};

export default NeighborProfileHeader;
